import useAppGlobal from "src/context/useAppGlobal";
import { v4 as uuid } from "uuid";
import TempExport from "../../inventory-out/TempExport";

export default function useInventoryAction() {
  const { handleOpenDialog } = useAppGlobal();
  const handleExpand = (item) => {
    handleOpenDialog({
      // title: "Tạo lệnh xuất/chuyển kho",
      size: "xl",
      content: <TempExport item={item} />,
    });
  };
  const action = [
    {
      id: uuid(),
      title: "Xuất/ Chuyển kho",
      onClick: (item) => handleExpand(item),
      type: "default",
      variant: "outlined",
    },
  ];
  return action;
}
